import React from 'react'
import '../App.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <>
      <div className="Footer">
        <div className="container">
          <div className="row">
            <div className="col-md-6 col-lg-5 col-12 ft-1">
              <h3>
                <span>VSN</span> Granites And Exports
              </h3>
              <p>
                We at VSN Granites and Expoters, are the manufacturers and
                granite exporters in Andhra Pradesh, India. We offer quality
                products in exquisite finishes and variety of colours to our
                clients. Today, we have established ourselves as one of the
                pioneers in the domain of granite exporters of India. We are one
                of the leading granite exporters in India with multiple export
                units to deliver all over India.
              </p>
              <div className="footer-icons">
                <i className="ri-facebook-circle-fill"></i>
                <i className="ri-instagram-fill"></i>

                <i className="ri-twitter-x-fill"></i>
                <i className="ri-youtube-fill"></i>

                <a
                  href="https://wa.me/9160940061?text=
                Hello Vsn granites and exports"
                  style={{ textDecoration: "none" }}
                >
                  <i className="ri-whatsapp-fill"></i>
                </a>
              </div>
            </div>
            <div className="col-md-6 col-lg-3 col-12 ft-2">
              <h5>Quick Links</h5>
              <ul>
                <li className="nav-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="nav-item">
                  <Link to="/products">Our Products</Link>
                </li>
                <li className="nav-item">
                  <Link to="#">Gallery</Link>
                </li>
                <li className="nav-item">
                  <a href="#">Infrastructure</a>
                </li>
                <li className="nav-item">
                  <a href="/contact">Contact Us</a>
                </li>
              </ul>
            </div>

            <div className="col-md-6 col-lg-4 col-12 ft-3">
              <h5>Contact Us</h5>
              <a
                href="tellto: +91 9160940061"
                style={{ textDecoration: "none" }}
              >
                <p>
                  <i className="ri-phone-fill"></i> +91 9160940061
                </p>
              </a>

              <a
                href="mailto: vsngraniteadnexports@gmail.com"
                style={{ textDecoration: "none" }}
              >
                <p>
                  <i className="ri-mail-fill"></i>vsngraniteadnexports@gmail.com
                </p>
              </a>
              <p>
                <i className="ri-map-pin-2-fill"></i>Sy.No.120/1, Kurnool Road,
                Yeluru -(V), Podili -(M), Prakasam dist, Andhrapradesh -523253.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="Last-footer">
        <p>CopyRights@2024</p>
      </div>
    </>
  );
}

export default Footer;